import Bugsnag from '@bugsnag/js'
import { Button, Result, Row } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

const Error404: React.FC = () => {
  const { formatMessage } = useIntl()

  useEffect(() => {
    Bugsnag.notify('User could not find the page he is looking for.', (event) => {
      event.severity = 'info'
    })
  }, [])

  return (
    <Row justify="center">
      <KCol card span={24}>
        <Result
          status="404"
          title="404"
          subTitle={formatMessage({ id: 'extraPages.404Msg' })}
          extra={
            <Link to="/">
              <Button type="primary">{formatMessage({ id: 'extraPages.goHome' })}</Button>
            </Link>
          }
        />
      </KCol>
    </Row>
  )
}

export default Error404
